if (typeof FlyerSection !== "function") {
  class FlyerSection extends HTMLElement {
    constructor() {
      super();

      this.ctaButton = null;
      this.serviceId = this.dataset.bookeasyServiceId || "";
      this.isBound = false;
    }

    connectedCallback() {
      if (this.isBound) {
        return;
      }

      this.addEventListener("click", this._handleBookeasyTrigger.bind(this));
      this.isBound = true;
    }

    _handleBookeasyTrigger(event) {
      const trigger = event.target.closest("[data-bookeasy-trigger]");

      if (!trigger || !this.contains(trigger)) {
        return;
      }

      this.serviceId =
        trigger.dataset.bookeasyServiceId ||
        this.dataset.bookeasyServiceId ||
        this.serviceId;

      const nativeButton = this._findBookeasyButton();

      if (!nativeButton) {
        return;
      }

      event.preventDefault();
      nativeButton.click();
    }

    _findBookeasyButton() {
      const selectors = [
        `.bookeasy-btn.bookeasy-btn-${this.serviceId}`,
        `.bookeasy-btn[data-product-id="${this.serviceId}"]`,
        `.bookeasy-appBlock-button[serviceid="${this.serviceId}"] .bookeasy-btn`,
        `.bookeasy-appBlock-button[serviceId="${this.serviceId}"] .bookeasy-btn`,
      ];

      for (const selector of selectors) {
        const button = document.querySelector(selector);

        if (button) {
          return button;
        }
      }

      return null;
    }
  }

  if (typeof customElements.get("flyer-section") == "undefined") {
    customElements.define("flyer-section", FlyerSection);
  }
}
